import React from "react";
import { Link } from "react-router-dom";

const CookWithUs = () => {
  const cardShadow = {
    boxShadow: "0 6px 20px rgba(0, 0, 0, 0.15)",
    backgroundColor: "rgba(255, 255, 255, 0.9)",
  };

  const textShadow = {
    textShadow: "1px 1px 4px rgba(0, 0, 0, 0.7)",
    color: "white",
  };

  return (
    <div>
      {/* Hero Section */}
      <div
        className="text-center text-white d-flex align-items-center"
        style={{
          height: "60vh",
          backgroundImage:
            "url('https://cdn.pixabay.com/photo/2014/12/04/11/55/sausage-556491_1280.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="container">
          <h1 className="display-4 fw-bold" style={textShadow}>
            Cook With Us
          </h1>
          <p className="lead mt-3" style={textShadow}>
            Join our culinary adventure! Learn to cook fresh, healthy meals with us.
          </p>
          {/* <Link to="/register" className="btn btn-warning fw-bold mt-3 px-4 py-2">
            Get Started
          </Link> */}
        </div>
      </div>

      {/* Info Section */}
      <div className="container py-5">
        <h2 className="text-center fw-bold mb-4">Why Join Our Cooking Program?</h2>
        <div className="row g-4">
          {[
            {
              title: "Live Cooking Sessions",
              desc: "Join weekly virtual classes with professional chefs and learn new dishes in real-time.",
              icon: "🍳",
            },
            {
              title: "Healthy Recipes",
              desc: "Access a curated library of nutritious recipes that are easy and affordable to make.",
              icon: "🥦",
            },
            {
              title: "Community Support",
              desc: "Be part of a cooking-loving community, share tips, and grow your kitchen confidence.",
              icon: "👨‍🍳",
            },
          ].map((item, index) => (
            <div className="col-md-4" key={index}>
              <div className="p-4 rounded text-center" style={cardShadow}>
                <div style={{ fontSize: "2rem" }}>{item.icon}</div>
                <h5 className="fw-bold mt-3">{item.title}</h5>
                <p className="text-muted">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Final CTA Section */}
      <div
        className="text-center text-white py-5 bg-dark"
       
      >
        <h3 className="fw-bold">Ready to cook something amazing?</h3>
        <p className="mb-4">Start your journey with us and elevate your kitchen game.</p>
        <Link to="/recipes" className="btn btn-light fw-bold px-4 py-2">
          Explore Recipes
        </Link>
      </div>
    </div>
  );
};

export default CookWithUs;
